var links = {
    TRANS_UNION_LINK: "tel:866-215-1713",
    ANNUAL_CREDIT_LINK: "https://www.annualcreditreport.com",
    DISPUTE_LINK: "https://dispute.transunion.com",
};
export default links;
